import { Component } from '@angular/core';
import { HelperService } from 'src/app/shared/helpers/helper.service';

@Component({
  selector: 'app-finder-privacy-policy',
  templateUrl: './finder-privacy-policy.component.html',
  styleUrl: './finder-privacy-policy.component.scss'
})
export class FinderPrivacyPolicyComponent {

  constructor(public helperService: HelperService) {}

}
